var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { AnalyticsClientService } from "../../../../../services/modules/analytics-client.service";
import * as Enumerable from "linq";
var LotteryAnalytics = /** @class */ (function (_super) {
    __extends(LotteryAnalytics, _super);
    function LotteryAnalytics(notificationService, i18N, analyticsClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.analyticsClientService = analyticsClientService;
        _this._openLotteryNameAnalyticsRepresentation = "ga:Dimension7";
        _this._brandNameAnalyticRepresentation = "ga:Dimension3";
        _this.isLoading = true;
        return _this;
    }
    LotteryAnalytics.prototype.onActivated = function (item) {
        this._lotteryName = item.name;
        this._brandName = item.navigationInfo ? item.navigationInfo.brandName : null;
    };
    LotteryAnalytics.prototype.attached = function () {
        var self = this;
        this.analyticsClientService.getToken().then(function (token) {
            window.gapi.analytics.ready(function () {
                var e_1, _a;
                window.gapi.analytics.auth.authorize({
                    'serverAuth': {
                        'access_token': token
                    }
                });
                var viewSelector = new window.gapi.analytics.ViewSelector({
                    container: 'view-selector-1-container'
                });
                viewSelector.execute();
                var filter = self._openLotteryNameAnalyticsRepresentation + "==" + self._lotteryName;
                if (self._brandName)
                    filter += ";" + self._brandNameAnalyticRepresentation + "==" + self._brandName;
                //overall chart
                var overallChart = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:hits,ga:users',
                        dimensions: 'ga:date',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        filters: filter
                    },
                    chart: {
                        container: 'overall-chart-container',
                        type: 'LINE',
                        options: {
                            width: '100%',
                        }
                    }
                });
                var hitsChartDate = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:hits',
                        dimensions: 'ga:date',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        filters: filter
                    },
                    chart: {
                        container: 'chart-hits-date',
                        type: 'LINE',
                        options: {
                            width: '100%'
                        }
                    }
                });
                var sessionChartCountry = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:hits',
                        dimensions: 'ga:country',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        'max-results': 6,
                        filters: filter
                    },
                    chart: {
                        container: 'chart-sessions-country',
                        type: 'PIE',
                        options: {
                            width: '100%',
                            pieHole: 4 / 9
                        }
                    }
                });
                var browserChart = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        'dimensions': 'ga:browser',
                        'metrics': 'ga:hits',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        'max-results': '6',
                        filters: filter
                    },
                    chart: {
                        type: 'TABLE',
                        container: 'chart-browsers',
                        options: {
                            width: '100%'
                        }
                    }
                });
                var visitorCountry = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:hits',
                        dimensions: 'ga:country',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        filters: filter
                    },
                    chart: {
                        container: 'visitor-country-container',
                        type: 'GEO',
                        options: {
                            width: '100%'
                        }
                    }
                });
                var newVsReturning = new window.gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:hits',
                        dimensions: 'ga:userType',
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday',
                        filters: filter
                    },
                    chart: {
                        container: 'new-returning-container',
                        type: 'PIE',
                        options: {
                            width: '100%'
                        }
                    }
                });
                viewSelector.on('change', function (ids) {
                    hitsChartDate.set({ query: { ids: ids } }).execute();
                    sessionChartCountry.set({ query: { ids: ids } }).execute();
                    overallChart.set({ query: { ids: ids } }).execute();
                    browserChart.set({ query: { ids: ids } }).execute();
                    visitorCountry.set({ query: { ids: ids } }).execute();
                    newVsReturning.set({ query: { ids: ids } }).execute();
                });
                var dataChartList = [hitsChartDate, sessionChartCountry, overallChart, browserChart, visitorCountry, newVsReturning];
                var _loop_1 = function (dataChart) {
                    dataChart.on('success', function (response) {
                        dataChart.loadingComplete = true;
                        self.disableLoading(dataChartList);
                    });
                };
                try {
                    for (var dataChartList_1 = __values(dataChartList), dataChartList_1_1 = dataChartList_1.next(); !dataChartList_1_1.done; dataChartList_1_1 = dataChartList_1.next()) {
                        var dataChart = dataChartList_1_1.value;
                        _loop_1(dataChart);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (dataChartList_1_1 && !dataChartList_1_1.done && (_a = dataChartList_1.return)) _a.call(dataChartList_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        });
    };
    LotteryAnalytics.prototype.disableLoading = function (dataChartList) {
        if (Enumerable.from(dataChartList).all(function (x) { return x.loadingComplete; })) {
            this.isLoading = false;
        }
    };
    LotteryAnalytics = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, AnalyticsClientService])
    ], LotteryAnalytics);
    return LotteryAnalytics;
}(ChildComponent));
export { LotteryAnalytics };
